import React from 'react';
import { StaticQuery, graphql, Link } from 'gatsby';
import styled from '@emotion/styled';
import { color, breakpoints } from '../../utils/style';
import Img from 'gatsby-image';
import Fire from "../../icons/svg/Fire"

const Wrapper = styled('div')`
  .h1 {
    margin: 2rem 0;
  }
  ul {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    list-style: none;
  }
  li {
    flex-basis: 32%;
    position: relative;
  }

  .item-link {
    position: relative;
    display: block;
    overflow: hidden;

    .image-container {
      position: relative;
      border-radius: 10px;
    }
    .button-container {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      padding: 20px;
      transition: all 0.2s ease-in-out;
      overflow: hidden;
      border-radius: 10px;
    }

    .gatsby-image-wrapper {
      border-radius: 10px;
    }

    .text-part-2 {
      padding: 7px 0 54px;
    }

    .h5 {
      display: block;
      font-size: 1.5rem;
      line-height: 2rem;
      color: ${color.white};
      max-height: 26px;
      margin: 24px 0;
      overflow: hidden;
    }

    .button {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -54px;
      margin-top: -25px;
      visibility: hidden;
      opacity: 0;
      transition: all 0.2s ease-in-out;
    }

    .excerpt {
      display: block;
      font-size: 14px;
      line-height: 20px;
      max-height: 99px;
      overflow: hidden;
    }

    &:hover,
    &:active {
      text-decoration: none;
      color: ${color.white};
      border: none;
      .button-container {
        background: rgba(0, 0, 0, 0.8);
      }
      .button {
        visibility: visible;
        opacity: 1;
      }
    }
    .gatsby-image-wrapper {
      height: 100%;
    }
  }

  @media (max-width: ${breakpoints.lg}) {
    li {
      flex-basis: 48%;
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    margin-bottom: 20px;
    .h3 {
      font-size: 18px;
      line-height: 20px;
      margin-bottom: 0.7rem;
    }
    li {
      flex-basis: 100%;
      margin-bottom: 20px;
    }
    .item-link {
      .h5 {
        margin: 0 0 10px;
      }
      .text-part-2 {
        padding: 7px 0 20px;
      }
    }
  }
`;

export default () => (
  <StaticQuery
    query={graphql`
      {
        allWordpressPost(
          filter: {
            categories: { elemMatch: { wordpress_id: { in: [51, 56, 57] } } }
            status: { eq: "publish" }
          }
          sort: { fields: date, order: DESC }
          skip: 0
          limit: 3
        ) {
          edges {
            node {
              slug
              title
              excerpt
              featured_media {
                alt_text
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 400) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
          }
        }
        placeholder: file(relativePath: { eq: "placeholder.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 400) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <Wrapper>
        <h2 className="h1 with-icon a-center">
          <Fire />
          <span>บทความล่าสุด</span>
        </h2>
        <ul>
          {data.allWordpressPost.edges.map(item => (
            <li key={item.node.label + item.node.slug}>
              <Link className="item-link" to={'/' + item.node.slug + '/'}>
                <div className="image-container">
                  {item.node.featured_media &&
                  item.node.featured_media.localFile &&
                  item.node.featured_media.localFile.childImageSharp ? (
                    <Img
                      fluid={
                        item.node.featured_media.localFile.childImageSharp.fluid
                      }
                      alt={item.node.featured_media.alt_text ? item.node.featured_media.alt_text : item.node.title}
                    />
                  ) : (
                    <Img
                      fluid={data.placeholder.childImageSharp.fluid}
                      alt={item.node.label}
                    />
                  )}
                  <div className="button-container">
                    <span className="button transparent-button-gold">คลิกเลย</span>
                  </div>
                </div>
                <div className="text-part-2">
                  <span className="h5">{item.node.title}</span>
                  <div
                    className="excerpt"
                    dangerouslySetInnerHTML={{ __html: item.node.excerpt }}
                  />
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </Wrapper>
    )}
  />
);
